import { Card } from '../models/skyclub.interfaces';
import { metThreshold, noneSpent, remainSpend } from './amex-tracker.mocks';
import {
  NonUnlimitedMocks,
  UnlimitedCardMocks,
  UnlimitedMembershipMocks
} from './unlimited.mocks';
import {
  VisitsScaleHighMocks,
  VisitsScaleLowMocks,
  VisitsScaleZeroMocks
} from './visits.mocks';

export const SingleCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks,
    spend: remainSpend
  }
];
export const SingleCardNotice: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleLowMocks,
    unlimited: NonUnlimitedMocks,
    spend: remainSpend
  }
];
export const SingleCardZero: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleZeroMocks,
    unlimited: NonUnlimitedMocks,
    spend: noneSpent
  }
];

export const SingleCardUnlimitedCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks,
    spend: metThreshold
  }
];

export const SingleCardUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedMembershipMocks,
    spend: remainSpend
  }
];

export const MultiCards: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks,
    spend: remainSpend
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleLowMocks,
    unlimited: NonUnlimitedMocks,
    spend: remainSpend
  }
];

export const MultiCardsUnlimitedCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks,
    spend: metThreshold
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks,
    spend: remainSpend
  }
];

export const MultiCardsUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    unlimited: UnlimitedMembershipMocks,
    spend: remainSpend
  },
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks,
    spend: metThreshold
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks,
    spend: noneSpent
  }
];

export const AllCardsUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    unlimited: UnlimitedMembershipMocks,
    spend: remainSpend
  },
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks,
    spend: metThreshold
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks,
    spend: metThreshold
  }
];

export const MultiCardCardMock: Card[] = [
  ...SingleCard,
  ...SingleCardNotice,
  ...SingleCardZero,
  ...SingleCardUnlimitedCard
];
